import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {guideLine} from './helper/helper-text';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class GuideComponent implements OnInit, AfterViewInit {

  keyGuide = Object.keys(guideLine);
  search1 = ''
  content = '';
  key = '';
  constructor(private router: ActivatedRoute) { }

  ngOnInit() {
    this.key = this.router.snapshot.queryParamMap.get('key');
    this.content =  this.key ? guideLine[this.keyGuide[ this.key]] : guideLine[this.keyGuide[0]];

  }
  selectGuide(key: string) {
    this.content = guideLine[key];
  }

  ngAfterViewInit(): void {
    if (!this.key) {
      (document.querySelector('.item') as HTMLElement).style.background = '#4BA6D3';
    } else {
      const div =  (document.querySelectorAll('.item'))[this.key];
      div.style.background = '#4BA6D3';
      const list = document.querySelector('.wrap__content--left-list');
      const top = div.offsetTop;
      list.scroll({top, behavior: 'auto'} );
    }
  }
  checkChange() {
    this.content =''
  }

  resetSearch() {
    this.search1 = ''
  }
}
